import productService from '../../services/ClassenService/modules/productService';

const state = {
  products: [],
  productsFacets: [],
  productQuickSelections: []
};

const getters = {
  getProducts: (state) => () => state.products,

  getProductsFacets: (state) => () => state.productsFacets,

  getProductQuickSelections() {
    return state.productQuickSelections;
  }
};

const mutations = {
  SET_PRODUCTS(products) {
    state.products = products;
  },

  SET_PRODUCTS_FACETS(facets) {
    state.productsFacets = facets;
  },

  ADD_PRODUCT_QUICKSELECTION(state, selectionItem) {
    state.productQuickSelections.push(selectionItem);
  }
};

const actions = {
  searchProducts: (context, {page, size, queryData}) => new Promise((resolve, reject) => {
    productService.searchProducts(page, size, queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  addSearchProductsToSelection: (context, queryData) => new Promise((resolve, reject) => {
    productService.addSearchProductsToSelection(queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  removeSearchProductsFromSelection: (context, queryData) => new Promise((resolve, reject) => {
    productService.removeSearchFromSelection(queryData)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject(error));
  }),

  getProduct: ({commit}, productId) => new Promise((resolve, reject) => {
    productService.getProduct(productId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getBevelColors: ({commit}, productId) => new Promise((resolve, reject) => {
    productService.getBevelColors()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getProductQuickSelection: (context, productId) => {
    let selectionItem = context.state.productQuickSelections.find((quick) => {
      return quick.productId === productId
    })

    if (!selectionItem) {
      productService.getProductQuickSelection(productId)
        .then((res) => {
          context.commit('ADD_PRODUCT_QUICKSELECTION', {
            productId: productId,
            quickSelection: res.data
          })
        });
    }

    return context.state.productQuickSelections
  },

  forceUpdateQuickSelectionProduct: (context, productId) => {
    let selectionItem = context.state.productQuickSelections.find((quick) => {
      return quick.productId === productId
    })

    let index = context.state.productQuickSelections.indexOf(selectionItem);
    context.state.productQuickSelections.splice(index, 1);

    productService.getProductQuickSelection(productId)
      .then((res) => {
        context.commit('ADD_PRODUCT_QUICKSELECTION', {
          productId: productId,
          quickSelection: res.data
        })
      });
  },

  updateProduct: ({commit}, productId, productData) => new Promise((resolve, reject) => {
    productService.updateProduct(productId, productData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteProduct: ({commit}, productId) => new Promise((resolve, reject) => {
    productService.deleteProduct(productId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addProduct: ({commit}, productData) => new Promise((resolve, reject) => {
    productService.addProduct(productData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getProductsFacets: ({commit}) => new Promise((resolve, reject) => {
    productService.getProductsFacets()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
